import React from "react";

export default function SiteHeader() {
    return (
        <header id="site-header">
            <h1 className="site-title">HIPPIE MODERNISM</h1>
        </header>
    );
}


// WEBPACK FOOTER //
// ./src/components/SiteHeader.js